import { Button } from "antd";
import * as React from "react";
import styled from "@emotion/styled";

const NotFoundWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ErrorMessageBox = styled("div")`
  position: relative;
  min-width: 800px;
  padding: 20px 10px 60px;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;

  &::before {
    content: "";
    position: absolute;
    display: block;
    top: -71px;
    right: 13px;
    width: 117px;
    height: 83px;
  }
`;

const ErrorCode = styled("div")`
  margin-bottom: 140px;
  font-size: 1.125rem;
  line-height: 28px;
`;

const ErrorCodeTitle = styled("span")`
  margin-left: 12px;
  vertical-align: -2px;
`;

const Code = styled("span")`
  vertical-align: -2px;
`;

const ErrorTitle = styled("h1")`
  margin-bottom: 1.875rem;
  padding-left: 36px;
  font-size: 2.25rem;
`;

const ErrorDesc = styled("div")`
  padding-left: 36px;
  line-height: 1.875;
`;

const NotFound: React.SFC = () => (
  <NotFoundWrapper>
    <ErrorMessageBox>
      <ErrorCode>
        <ErrorCodeTitle>Error</ErrorCodeTitle>
        <Code> | 404</Code>
      </ErrorCode>
      <ErrorTitle>
        Sorry, Page Not Found ☹️
        <br />
        페이지를 찾을 수 없습니다.
      </ErrorTitle>
      <ErrorDesc>
        주소가 잘못 입력되었거나 이 페이지에 권한이 없습니다.
        <br />
        <br />
        <Button>Go Back</Button>&nbsp;&nbsp;
        <Button>Go Landing</Button>&nbsp;&nbsp;
        <Button>Help</Button>
      </ErrorDesc>
    </ErrorMessageBox>
  </NotFoundWrapper>
);

export default NotFound;
